<template>
    <component :is="data.name" v-bind="data.params"></component>
</template>
<script>
import ImportOldOppOverviewNote from 'vcomponents/popups/overviews/ImportOldOppOverviewNote.vue';
export default {
    components: {
        'import-old-note': ImportOldOppOverviewNote,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
};
</script>
